import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { ChangeSetConvertDialogData } from '@components/change-set-convert-dialog/1.0';
import { ButtonStyle } from '@constants/button/1.0';
import { MessageType } from '@constants/message/1.0';
import { ThemePalette } from '@angular/material/core';
import { ChangeSetItem, ChangeSetItemType } from '@interfaces/change-sets/1.0';
import { CapitalizeService } from '@services/utilities/1.0/capitalize.service';
import {
  NGX_MAT_DATE_FORMATS,
  NgxMatDateFormats,
  NgxMatDatetimePickerModule,
} from '@nng-components/angular-material-datetime-picker';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeepCloneService } from '@services/utilities/1.0/deep-clone.service';
import { DateService } from '@services/utilities/1.0/date.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { MatFormField, MatLabel, MatHint, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatDatepickerToggle } from '@angular/material/datepicker';
import { MatIconButton } from '@angular/material/button';
import { ButtonComponent } from '../../button/1.0/button.component';
import { TranslateModule } from '@ngx-translate/core';

export const CUSTOM_DATE_FORMATS: NgxMatDateFormats = {
  parse: {
    dateInput: 'MM/dd/yy hh:mm a',
  },
  display: {
    dateInput: 'MM/dd/yy hh:mm a',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};

@Component({
  selector: 'txp-change-set-convert-dialog',
  templateUrl: './change-set-convert-dialog.component.html',
  styleUrls: ['./change-set-convert-dialog.component.scss'],
  providers: [{ provide: NGX_MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }],
  standalone: true,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    NgIf,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    NgxMatDatetimePickerModule,
    ReactiveFormsModule,
    MatHint,
    MatDatepickerToggle,
    MatSuffix,
    MatIconButton,
    MatDialogActions,
    ButtonComponent,
    TranslateModule,
  ],
})
export class ChangeSetConvertDialogComponent {
  buttonStyle = ButtonStyle;
  disableContinueBtn: boolean;
  isSaving: boolean;
  showError: boolean;
  messageType = MessageType;
  errorMessage: string;
  minDate: any;
  scheduleDateControl: FormControl;
  changeSet: ChangeSetItem;
  oppositeVersion: ChangeSetItemType;

  public color: ThemePalette = 'primary';

  constructor(
    private dialogRef: MatDialogRef<ChangeSetConvertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeSetConvertDialogData,
    private dateService: DateService,
  ) {
    const now = new Date();
    // Get next day's start and subtract 1 millisecond to get end of current day
    const nextDay = this.dateService.add(this.dateService.startOf(now, 'day'), 1, 'day');
    const endOfDay = this.dateService.add(nextDay, -1, 'millisecond');

    this.changeSet = DeepCloneService.clone(this.data.item);
    this.changeSet.scheduledTimestamp =
      data.oppositeVersion?.scheduledTimestamp || this.dateService.formatLocalDateTime(endOfDay);
    this.oppositeVersion =
      this.changeSet.type === ChangeSetItemType.DRAFT
        ? ChangeSetItemType.SCHEDULED
        : ChangeSetItemType.DRAFT;

    const minDate = this.dateService.add(now, 1, 'hour');
    this.minDate = this.dateService.formatLocalDateTime(minDate);
    this.scheduleDateControl = new FormControl(this.changeSet.scheduledTimestamp);
  }

  onScheduleDateChange(event) {
    this.changeSet.scheduledTimestamp = this.dateService.formatLocalDateTime(event.value);
  }

  capitalizeVersion(value) {
    return CapitalizeService.capitalize(value.toLowerCase());
  }

  onCancel() {
    this.dialogRef.close(null);
  }

  onSave() {
    this.dialogRef.close({
      ...this.changeSet,
      type: this.oppositeVersion,
    });
  }
}
